<template>
    <v-container
      class="main-container"
      fill-height
    >
      <v-row justify="center" align="center">
        <v-col cols="8">
          <v-card color="grey lighten-3 pa-5">            
            <v-card-title class="justify-center">{{ $t('individualVatRecordReport') }}</v-card-title>
            <v-card-text class="mt-8">
            <v-row>
              <v-col>
                <v-menu
                v-model="menuFrom"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
                >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    v-model="report.fromDate"
                    v-bind:label="$t('dateFrom')"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="report.fromDate"
                    no-title
                    scrollable
                    min="2017-01-01"
                    max="2050-01-01"
                    @input="menuFrom = false"
                >
              </v-date-picker>
              </v-menu>
              
              </v-col>
              <v-col>
              <v-menu
                    v-model="menuTo"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                        v-model="report.toDate"
                        v-bind:label="$t('dateTo')"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="report.toDate"
                        no-title
                        scrollable
                        min="2017-01-01"
                        max="2050-01-01"
                        @input="menuTo = false"
                    >
                </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>            
          </v-card-text>
            <v-card-actions class="justify-center mt-5">
              <v-btn :disabled="reportGenerating" @click="getReport()">{{ $t('getReport') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
      export default {
          name: "IndividualVatRecordReport",
          data() {
              return{
                reportGenerating: false,
                report: {
                  organizationId: 0,
                  fromDate: "",
                  toDate: "",
                  documentType: "",
                  itemsCode: ""
                },
                menuFrom: false,
                menuTo: false,
                message: "",
                documentTypesItems: []
              }
          },
          computed: {
            selectedOrganization() {
              return this.$store.getters.organizationId;
            }
          },
          methods: {
          getReport() {
              if(this.report.fromDate.length > 0 && this.report.toDate.length > 0) {
                this.report.organizationId = this.selectedOrganization;
                var formData = new FormData()
                formData.append('reportJson', JSON.stringify(this.report))
                this.reportGenerating = true;
  
                this.axios.post('Report/IndividualVatRecordReport', formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }, responseType: 'blob',
                }).then(response => {
                  if(response && response.status === 200) {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
            
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download',  'PojedinacnaPDVEvidencija' + this.report.fromDate + '-' + this.report.toDate + '.xlsx');
                    document.body.appendChild(fileLink);
          
                    fileLink.click();
                    this.reportGenerating = false;
                  }
                })
                .catch(function (error) {
                    console.log(error)
                    if (error.response) {
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    }
                    else if (error.request) {
                      console.log(error.request);
                    } 
                    this.reportGenerating = false;
                })
              }
              else {
                this.$root.displayNotificationMsg(this.$t('bothDateRequired'), 'warning')
              }
            },
            getDocumentTypeText(item) {
              if(localStorage.getItem('language') === 'eng')
                return item.documentTypeEng;
              else
                return item.documentType;
            },
          }
      }
  </script>
  
  